export const gettingCenters = "@/center/@gettingAll";
export const getCentersSuccess = "@/center/@getAllSuccess";
export const getCentersFailure = "@/center/@getAllFailure";

// export const registerIn = "@/center/@registerStart";
// export const registerSuccess = "@/center/@registerSuccess";
// export const registerFailure = "@/center/@registerFailure";
